import Loading from "@/Loading.vue";
import PaymentCanceled from "@/PaymentCanceled.vue";
import PaymentCheck from "@/PaymentCheck.vue";
import PaymentFailedUsedId from "@/PaymentFailedUsedId.vue";
import PaymentSuccess from "@/PaymentSuccess.vue";
//import VideoCorsi from "@/VideoCorsi.vue";
import PrivacyPolicy from "@/PrivacyPolicy.vue";
import Subscription from "@/Subscription.vue";
import SubscriptionPage from "@/SubscriptionPage.vue";
//import Welcome from "@/Welcome.vue";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/video-corsi",
  //   name: "Video Corsi",
  //   component: VideoCorsi
  // },
  {
    path: "/privacy",
    name: "Privacy Policy",
    component: PrivacyPolicy
  },
  {
    path: "/subscription",
    component: SubscriptionPage,
    children: [
      {
        path: '',
        name: 'Subscription',
        component: Subscription
      },
      {
        path: 'checkout/:checkout_session_id',
        name: 'Payment Check',
        component: PaymentCheck
      },
      {
        path: 'failed',
        name: 'Payment Error',
        component: PaymentFailedUsedId
      },
      {
        path: 'cancel',
        name: 'Payment Error',
        component: PaymentCanceled
      },
      {
        path: 'success',
        name: 'Payment Success',
        component: PaymentSuccess
      },
    ]
  },
  {
    path: "/",
    name: "SelfDiet",
    component: Loading,
    //component: Welcome,
    children: [
      // {
      //   path: "/video-corsi",
      //   name: "Video Corsi",
      //   component: VideoCorsi
      // },
      {
        path: "/privacy",
        name: "Privacy Policy",
        component: PrivacyPolicy
      },
      {
        path: "/subscription",
        component: SubscriptionPage,
        children: [
          {
            path: '',
            name: 'Subscription',
            component: Subscription
          },
          {
            path: 'checkout/:checkout_session_id',
            name: 'Payment Check',
            component: PaymentCheck
          },
          {
            path: 'failed',
            name: 'Payment Error',
            component: PaymentFailedUsedId
          },
          {
            path: 'cancel',
            name: 'Payment Error',
            component: PaymentCanceled
          },
          {
            path: 'success',
            name: 'Payment Success',
            component: PaymentSuccess
          },
        ]
      },
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
